import { ObjectType, Field, InputType, Int, ID } from 'type-graphql'

import { ObjectRef, ScalarObject } from '@things-factory/shell'
import { KpiPeriodType } from '../kpi/kpi'

import { KpiStatistic } from './kpi-statistic.js'

@InputType()
export class NewKpiStatistic {
  @Field({ nullable: true })
  kpi?: ObjectRef

  @Field({
    description:
      'Date or period for which this statistic is calculated (e.g., day: YYYY-MM-DD, month: YYYY-MM, quarter: YYYY-Qn, range: YYYY-MM-DD~YYYY-MM-DD).'
  })
  valueDate: string

  @Field(type => KpiPeriodType)
  periodType: KpiPeriodType

  // 핵심 통계 필드들
  @Field({ nullable: true })
  count?: number

  @Field({ nullable: true })
  sum?: number

  @Field({ nullable: true })
  range?: number

  @Field({ nullable: true })
  mean?: number

  @Field({ nullable: true })
  median?: number

  @Field({ nullable: true })
  minimum?: number

  @Field({ nullable: true })
  maximum?: number

  @Field({ nullable: true })
  standardDeviation?: number

  @Field({ nullable: true })
  variance?: number

  @Field({ nullable: true })
  percentile25?: number

  @Field({ nullable: true })
  percentile75?: number

  @Field({ nullable: true })
  iqr?: number

  @Field({ nullable: true })
  lowerFence?: number

  @Field({ nullable: true })
  upperFence?: number

  // 확장 필드들
  @Field(type => ScalarObject, { nullable: true })
  additionalStatistics?: { [metricName: string]: number }

  @Field(type => ScalarObject, { nullable: true })
  metadata?: { [key: string]: any }
}

@InputType()
export class KpiStatisticPatch {
  @Field(type => ID, { nullable: true })
  id?: string

  @Field({ nullable: true })
  kpi?: ObjectRef

  @Field({
    nullable: true,
    description:
      'Date or period for which this statistic is calculated (e.g., day: YYYY-MM-DD, month: YYYY-MM, quarter: YYYY-Qn, range: YYYY-MM-DD~YYYY-MM-DD).'
  })
  valueDate?: string

  @Field(type => KpiPeriodType, { nullable: true })
  periodType?: KpiPeriodType

  // 핵심 통계 필드들
  @Field({ nullable: true })
  count?: number

  @Field({ nullable: true })
  sum?: number

  @Field({ nullable: true })
  range?: number

  @Field({ nullable: true })
  mean?: number

  @Field({ nullable: true })
  median?: number

  @Field({ nullable: true })
  minimum?: number

  @Field({ nullable: true })
  maximum?: number

  @Field({ nullable: true })
  standardDeviation?: number

  @Field({ nullable: true })
  variance?: number

  @Field({ nullable: true })
  percentile25?: number

  @Field({ nullable: true })
  percentile75?: number

  @Field({ nullable: true })
  iqr?: number

  @Field({ nullable: true })
  lowerFence?: number

  @Field({ nullable: true })
  upperFence?: number

  // 확장 필드들
  @Field(type => ScalarObject, { nullable: true })
  additionalStatistics?: { [metricName: string]: number }

  @Field(type => ScalarObject, { nullable: true })
  metadata?: { [key: string]: any }

  @Field({ nullable: true })
  cuFlag?: string
}

@ObjectType()
export class KpiStatisticList {
  @Field(type => [KpiStatistic])
  items: KpiStatistic[]

  @Field(type => Int)
  total: number
}
